import styled from 'styled-components'

import {
  WHITE,
  SDB,
  SDR,
  SO,
  SDB10S,
  SDR10S,
  SO10S,
  PG,
  PG10S
} from '@h2/components/colors'
import { Link } from '@h2/common/components/link'
import { vagRundFont } from '@h2/components/mixins'

const colors = {
  blue: SDB,
  red: SDR,
  orange: SO,
  green: PG
}
const hoverBgColors = {
  blue: SDB10S,
  red: SDR10S,
  orange: SO10S,
  green: PG10S
}
const StyledButton = styled.button`
  ${vagRundFont}
  color: ${WHITE};
  width: 55%;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ color }) => colors[color]};
  border-radius: 4px;
  padding: 6px 10px;
  cursor: pointer;
  text-decoration: none;
  border: none;
  margin-top: auto;

  &:hover {
    background-color: ${({ color }) => hoverBgColors[color]};
    text-decoration: none;
    color: ${WHITE};
  }
`
const PromotionButton = ({
  children,
  color,
  hasModal,
  setOpenModal,
  size = 'medium',
  ...props
}) => {
  const externalLink = /^https?:\/\//
  /*
   * external links should function the same as serverside rendered and bypass the router.
   * A similar idea for links that open in a new target
   */
  const ssr = Boolean(props.target) || externalLink.test(props.href)
  const addProps = hasModal
    ? { onClick: () => setOpenModal(true), ...props }
    : { ssr, ...props }

  return (
    <StyledButton size={size} as={hasModal ? '' : Link} color={color} {...addProps}>
      {children}
    </StyledButton>
  )
}

export { PromotionButton }
